export const GET_RECENT_EXPENSE_RECORDS = 'GET_RECENT_EXPENSE_RECORDS'
export const GET_RECENT_EXPENSE_RECORDS_FAILED = 'GET_RECENT_EXPENSE_RECORDS_FAILED'
export const GET_RECENT_EXPENSE_RECORDS_SUCCEEDED = 'GET_RECENT_EXPENSE_RECORDS_SUCCEEDED'
